// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  functions: {
    getFirebaseUid: 'https://us-central1-shoutout-c6349.cloudfunctions.net/getFirebaseUid'
  },
  firebase: {
    apiKey: 'AIzaSyAtiRRlm3Q8qA2vtyymgiGw5S6HJWLout0',
    authDomain: 'shoutout-c6349.firebaseapp.com',
    databaseURL: 'https://shoutout-c6349.firebaseio.com',
    projectId: 'shoutout-c6349',
    storageBucket: 'shoutout-c6349.appspot.com',
    messagingSenderId: '841297967655',
  },
  maps: {
    apiKey: "AIzaSyCT4YwVP9VgmmCCCr86O54gz89nQsghhlQ"
  }
};



// WEBPACK FOOTER //
// /app/src/environments/environment.ts